import { render, staticRenderFns } from "./SampleImages.vue?vue&type=template&id=136b0522"
import script from "./SampleImages.vue?vue&type=script&lang=js"
export * from "./SampleImages.vue?vue&type=script&lang=js"
import style0 from "./SampleImages.vue?vue&type=style&index=0&id=136b0522&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports